import { initMaps, map as fmap } from '@defra/forms-engine-plugin/shared.js'

import { configureMapLibreWorker } from './maplibre-worker-url.js'

import { readLpaBounds, toMaxBounds } from './lpa-bounds.js'

let hasAddressCentre = false

// Centre the geospatial map on the address chosen in the address-lookup step.
// The server renders the easting/northing into #map-initial-center; mutate the
// shared defaultConfig before initMaps so processGeospatial picks up the centre.
const centerEl = document.getElementById('map-initial-center')
if (centerEl?.textContent) {
  try {
    const { easting, northing } = JSON.parse(centerEl.textContent)
    const { lat, long } = fmap.eastingNorthingToLatLong({
      easting: Number(easting),
      northing: Number(northing)
    })
    if (Number.isFinite(lat) && Number.isFinite(long)) {
      fmap.defaultConfig.center = [long, lat]
      fmap.defaultConfig.zoom = '16'
      hasAddressCentre = true
    }
  } catch {
    // Ignore malformed centre data and fall back to the default map view.
  }
}

// Keep the map within the LPA, and open on the whole LPA when there's no
// address to centre on. The engine sets `bounds` to any shapes already drawn,
// which takes precedence over `extent`.
const lpaBounds = readLpaBounds()
if (lpaBounds) {
  fmap.defaultConfig.maxBounds = toMaxBounds(lpaBounds)
  if (!hasAddressCentre) {
    fmap.defaultConfig.extent = lpaBounds
  }
}

// Leave the map's height to the .map-container CSS rule rather than an inline
// style, so it matches the space the page reserves before the map loads.
fmap.defaultConfig.containerHeight = ''

// initMaps() is a no-op when neither field class is present on the page, so
// only pay for the MapLibre worker setup when a map is actually going to load.
const hasMap =
  document.querySelector('.app-location-field') ??
  document.querySelector('.app-geospatial-field')

const mapsConfig = {
  assetPath: '/assets',
  apiPath: '/api',
  data: {
    VTS_OUTDOOR_URL: '/api/maps/vts/OS_VTS_3857_Outdoor.json',
    VTS_DARK_URL: '/api/maps/vts/OS_VTS_3857_Dark.json',
    VTS_BLACK_AND_WHITE_URL: '/api/maps/vts/OS_VTS_3857_Black_and_White.json',
    VTS_AERIAL_URL: '/api/maps/vts/esri-aerial.json'
  }
}

if (hasMap) {
  // Fire this off before initMaps — both it and the interactive map's own
  // lazy `import('maplibre-gl')` resolve the same cached chunk promise, and
  // callbacks run in attachment order, so setWorkerUrl is guaranteed to run
  // before the map creates its worker. Best-effort: initMaps runs regardless.
  configureMapLibreWorker().catch((error) => {
    console.error('Failed to configure the MapLibre worker URL', error)
  })
}

initMaps(mapsConfig)

// initMaps adds the map, and the list of drawn shapes below it, straight after
// the field's textarea. On /find-the-new-site, move them into the slots the
// template reserves: a full-width row for the map and a two-thirds column for
// the list. This runs before the map loads, so the page doesn't jump.
function moveIntoSlot(slotId, elementId) {
  const slot = document.getElementById(slotId)
  const element = document.getElementById(elementId)
  if (slot && element) {
    slot.replaceWith(element)
  }
}

moveIntoSlot('site-boundary-map-slot', 'geospatialmap_0')
moveIntoSlot('site-boundary-list-slot', 'geospatialmap_0_list')
